let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("d5Lgc")).then(() => parcelRequire('6QY4I'));